import appConfig from 'config'
// import delay from '@redux-saga/delay-p'
import { call, put } from 'redux-saga/effects'
import apiRequest from '../../common/apiRequest'
import {
  loadWhitelabelRequest,
  CREATE_GOOGLE_ANALYTICS_PROPERTY,
} from 'app/redux-base/actions/configurator'
import NotificationType from 'app/redux-base/enums/NotificationType'
import {
  showNotification,
  clearNotifications,
} from 'app/redux-base/actions/notifications'

export default function* createGaProperty(action) {
  const {
    payload: { wlId },
  } = action
  yield put(clearNotifications())

  const url = `${appConfig.BASE_URL_V2}/whitelabels/whitelabel/${wlId}/create_ga_id/`

  const apiCall = apiClient => apiClient.post(url)
  yield apiCall

  const { response, error } = yield call(
    apiRequest,
    apiCall,
    CREATE_GOOGLE_ANALYTICS_PROPERTY,
    action
  )

  if (response) {
    yield put(
      showNotification({
        type: NotificationType.INFO,
        message: 'GA property successfully created',
      })
    )
    // update config from API to fill GA ID input
    yield put(loadWhitelabelRequest({ id: wlId, showLoading: false }))

    action.resolvePromise()
  } else {
    // show error
    yield put(
      showNotification({
        type: NotificationType.ERROR,
        title: 'Creation of GA property failed',
        message: error.message || 'unkonwn server error',
      })
    )

    action.rejectPromise()
  }
}
